'use client';

import { forwardRef, useId } from 'react';

import { css, cx } from '@/styled-system/css';

import { MenuGroupContext } from './context/menu-group.context';
import type { MenuGroupPropsInterface } from './types/menu-group.types';

/**
 * @since 10.0.0
 */
export const MenuGroup = forwardRef<HTMLDivElement, MenuGroupPropsInterface>(
  (props: MenuGroupPropsInterface, forwardedRef) => {
    const { 'aria-label': ariaLabel, className, 'css': cssProp, ...rest } = props;
    const id = useId();
    return (
      <MenuGroupContext.Provider value={{ id }}>
        <div
          ref={forwardedRef}
          data-c11n-component="Menu.Group"
          data-c11n-version={__C11N_VERSION__}
          className={cx('c11n', css(cssProp), className)}
          role="group"
          aria-describedby={ariaLabel ? undefined : id}
          aria-label={ariaLabel}
          {...rest}
        />
      </MenuGroupContext.Provider>
    );
  },
);

MenuGroup.displayName = 'Menu.Group';
